import { Field, Modal, TextField, ActionButton, Autocomplete, DatePicker } from 'components/commons';
import { useApi, useForm, useModal } from 'hooks';
import React, { useMemo } from 'react';
import { initialState as formState } from './customer-form.state';
import styles from './customer.module.scss';
import { NotifModal } from 'components/modals';
import { Grid } from '@material-ui/core';
import locale from 'localization';
import { useEffect } from 'react';
import { CarWithLady } from 'images';
import { handleRequest } from 'utils';
import { createCustomer, updateCustomer } from 'apis/customer.api';

const CustomerForm = ({ initialState, actionText, view, create, customerId, refreshPage, ...state }) => {
  const { close } = state;
  const notifModal = useModal();
  const form = useMemo(() => {
    return formState(initialState);
  }, [initialState]);

  const { fields, modifyField, submitForm, getFormValues, validateField, clearForm, isFormSubmittable } = useForm({
    initialState: form
  });

  useEffect(() => {
    if (state.active) {
      clearForm();
    }
    //eslint-disable-next-line
  }, [state.active]);

  const addCustomerRequest = useApi({
    api: createCustomer,
    handleOwnError: {
      badrequest: true
    }
  });

  const editCustomerRequest = useApi({
    api: updateCustomer,
    handleOwnError: {
      badrequest: true
    },
    params: {
      customerId
    }
  });

  const loading = addCustomerRequest.loading || editCustomerRequest.loading;

  const submit = async () => {
    const params = getFormValues();

    const apiRequest = create ? addCustomerRequest : editCustomerRequest;

    handleRequest(async () => {
      const finalParams = {
        ...params
      };
      await apiRequest.request(finalParams, () => submit());

      close();
      refreshPage();
      notifModal.show({
        image: CarWithLady,
        title: create ? locale.customerSuccessRegistered : locale.customerSuccessEdited,
        contentHighlight: [<b>{params.firstName}</b>, <b>{params.lastName}</b>],
        content: create ? locale.successfullyRegisteredCustomerName : locale.successfullyChangeInfoOfCustomerName,
        secondary: create
          ? {
              text: locale.registerNewCustomer,
              onClick: () => {
                state.show({
                  title: 'Add Customer',
                  actionText: locale.add,
                  create: true
                });
              }
            }
          : null
      });
    });
  };

  return (
    <div>
      <NotifModal {...notifModal} />
      <Modal close={loading ? false : close} {...state} className={styles.modalContent}>
        <div className={styles.formContent}>
          <div className={styles.content}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field className={styles.status} label="Membership Type">
                  <Autocomplete
                    name="type"
                    value={fields.type}
                    options={[
                      {
                        label: 'Regular Member',
                        value: 'Regular Member'
                      },
                      {
                        label: 'Associate Member',
                        value: 'Associate Member'
                      }
                    ]}
                    {...fields.type}
                    onChange={modifyField}
                  />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field {...fields.membershipId}>
                  <TextField {...fields.membershipId} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.bodApprovalDate}>
                  <DatePicker {...fields.bodApprovalDate} placeholder={locale.preferredDate} onChange={modifyField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.boardResolutionNumber}>
                  <TextField {...fields.boardResolutionNumber} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field {...fields.firstName}>
                  <TextField {...fields.firstName} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.lastName}>
                  <TextField {...fields.lastName} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.middleName}>
                  <TextField {...fields.middleName} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field {...fields.civilStatus}>
                  <Autocomplete
                    name="civilStatus"
                    value={fields.civilStatus}
                    options={[
                      {
                        label: 'Single',
                        value: 'Single'
                      },
                      {
                        label: 'Married',
                        value: 'Married'
                      },
                      {
                        label: 'Separated',
                        value: 'Separated'
                      },
                      {
                        label: 'Widowed',
                        value: 'Widowed'
                      }
                    ]}
                    {...fields.civilStatus}
                    onChange={modifyField}
                  />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field className={styles.gender} label="Gender">
                  <Autocomplete
                    name="gender"
                    value={fields.type}
                    options={[
                      {
                        label: 'Male',
                        value: 'Male'
                      },
                      {
                        label: 'Female',
                        value: 'Female'
                      }
                    ]}
                    {...fields.gender}
                    onChange={modifyField}
                  />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.religion}>
                  <TextField {...fields.religion} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field {...fields.dateOfBirth}>
                  <DatePicker {...fields.dateOfBirth} placeholder={locale.preferredDate} onChange={modifyField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.placeOfBirth}>
                  <TextField {...fields.placeOfBirth} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={6}>
                <Field {...fields.address}>
                  <TextField {...fields.address} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field {...fields.mobileNumber}>
                  <TextField {...fields.mobileNumber} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.emailAddress}>
                  <TextField {...fields.emailAddress} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field {...fields.fatherName}>
                  <TextField {...fields.fatherName} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.motherName}>
                  <TextField {...fields.motherName} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field {...fields.educationalAttainment}>
                  <TextField {...fields.educationalAttainment} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.work}>
                  <TextField {...fields.work} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Field {...fields.spouseName}>
                  <TextField {...fields.spouseName} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field {...fields.spouseWork}>
                  <TextField {...fields.spouseWork} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={3}>
                <Field {...fields.tinNo}>
                  <TextField {...fields.tinNo} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field {...fields.sssNo}>
                  <TextField {...fields.sssNo} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field {...fields.philhealthNo}>
                  <TextField {...fields.philhealthNo} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field {...fields.pagibigNo}>
                  <TextField {...fields.pagibigNo} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={3}>
                <Field {...fields.emergencyContactName}>
                  <TextField {...fields.emergencyContactName} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field {...fields.emergencyContactNumber}>
                  <TextField {...fields.emergencyContactNumber} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field {...fields.emergencyContactRelationship}>
                  <TextField {...fields.emergencyContactRelationship} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={6}>
                <Field {...fields.emergencyContactAddress}>
                  <TextField {...fields.emergencyContactAddress} onChange={modifyField} onBlur={validateField} />
                </Field>
              </Grid>
            </Grid>
          </div>
        </div>
        {!view && (
          <ActionButton
            right
            items={[
              {
                onClick: () => {
                  state.close();
                },
                disabled: loading,
                text: locale.cancel
              },
              {
                onClick: () => {
                  submitForm(submit);
                },
                disabled: !isFormSubmittable,
                loading,
                text: actionText
              }
            ]}
          />
        )}
      </Modal>
    </div>
  );
};

export default CustomerForm;
